import qs from 'qs';
import instance, { PPR_API_URL } from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { ITask } from './interfaces';

export const getTaskList = (params: IDynamicTableParams) => {
  return instance(true, PPR_API_URL)
    .get<ITask[]>(`/task/list`, {
      params,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
    })
    .then((response) => response.data);
};

export const getTaskAvailableColumns = () => {
  return instance(true, PPR_API_URL)
    .get<IAvailableColumnModel[]>(`/task/availableColumns`)
    .then((response) => response.data);
};

export const getTaskAvailableGroupColumns = () => {
  return instance(true, PPR_API_URL)
    .get<IAvailableGroupColumnModel[]>(`/task/availableGroupColumns`)
    .then((response) => response.data);
};
